module.exports = __webpack_public_path__ + "media/images/home/concept_scene_5_sp-05507bb557ea3fa11bf7b026d642ec7e.png";